import { FC } from 'react';
import { GiftFinderMainContentStoryblok } from 'storyblok-types';
import { components } from 'pages/StoryBlok/component';
import { IServerProps } from 'pages/StoryBlok/types';

export const GiftFinderMainContent: FC<{
  blok: GiftFinderMainContentStoryblok;
  serverProps?: IServerProps;
}> = ({ blok, serverProps }) => {
  return blok.content?.map((blok) => {
    const Component = (components?.[blok.component] as any) || null;

    return !Component ? null : (
      <Component key={blok._uid} blok={blok} serverProps={serverProps} />
    );
  });
};
